import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.css'

const GetStartedPackage = ({
  plan,
  price,
  priceAbout,
  revenue,
  color,
  recommended
}) => {
  return (
    <div className="tc mb5">
      <h3 className="ttu f10 lh-title mt0 mb4 fw4">{plan}</h3>

      <div className="mb5">
        <p className="mv0 f4 fw7 ttu lh-title">{price}</p>
        <p
          className={classNames({
            'f11 lh-title mv0': true,
            'light-silver': !recommended,
            'pv1 ph3 br4 white dib ttu': recommended
          })}
          style={{ backgroundColor: recommended && color }}
        >
          {priceAbout}
        </p>
      </div>

      <div
        className="mw300 center f12 lh-title light-silver ttu bb bw3 pv1"
        style={{ borderColor: color }}
      >
        {revenue}
      </div>
    </div>
  )
}

GetStartedPackage.propTypes = {
  plan: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  priceAbout: PropTypes.string
}

export default GetStartedPackage



// WEBPACK FOOTER //
// ./src/components/get-started-package/get-started-package-header.js